import { configApiRef, useApi } from '@backstage/core-plugin-api';

/**
 * Chave de configuracao da feature flag do Skill Vault
 * (`spassuCode.features.skillVault`, env `SKILL_VAULT_FEATURE_FLAG`).
 */
export const SKILL_VAULT_FEATURE_FLAG_KEY = 'spassuCode.features.skillVault';

/**
 * Feature flag do Skill Vault. Controla o item do menu lateral e a rota
 * `/spassu-code/skills`. Chave ausente equivale a desligado.
 */
export function useSkillVaultEnabled(): boolean {
  const config = useApi(configApiRef);
  return config.getOptionalBoolean(SKILL_VAULT_FEATURE_FLAG_KEY) ?? false;
}
